module.exports = __webpack_public_path__ + "img/P150T_weapon_50.872c8870.png";